import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { createColumnHelper } from "@tanstack/react-table";
import ReactTable from "../../../components/ReactTable";
import editBond from "../../../assets/editBond.png";
import axios from "axios";
import CustomPagination from "../../../components/CustomPagination";
import AddCardDetailsModal from "./CardDetailsModal";
import AddHandpickedBondModal from "./HandPickedBondModal";
import { useSelector, useDispatch } from "react-redux";
import { BsPlusSquare } from "react-icons/bs";
import AddFAQModal from "./FaqModal";
import AddTestimonialModal from "./TestimonialModal";
import { updateCmsData } from "../../../redux/cmsSlice";
import { toast } from "react-toastify";
import delBond from "../../../assets/deleteBond.png";

export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;
function HomePagemanage() {
  const columnHelper = createColumnHelper();
  const [activeTab, setActiveTab] = useState(0); // Default to the first tab
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [testimonialEditData, setTestimonialEditData] = useState();
  const [faqEditData, setFaqEditData] = useState();
  const [bondEditData, setbondEditData] = useState();
  const { cmsData, cmsBondListData } = useSelector((state) => state.cmsData);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const [cardEditData, setCardEditData] = useState(null);

  const uploadData = async (uploadData) => {
    const endpoint = `${base_url}/${api_type}/cms/homeContent/set`;

    try {
      const response = await axios.post(endpoint, uploadData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });
      
      // Update Redux store
      dispatch(updateCmsData(uploadData));
      
      // Update local state based on active tab
      switch (activeTab) {
        case 0:
          setData(uploadData.homeCards || []);
          break;
        case 1:
          if (uploadData.bondIds && cmsBondListData) {
            const bondIdStatusMapping = uploadData.bondIds.reduce((acc, bond) => {
              acc[bond.id] = bond.status;
              return acc;
            }, {});

            const filteredBondData = cmsBondListData
              .filter((item) => bondIdStatusMapping.hasOwnProperty(item.id))
              .map((item) => ({
                ...item,
                status: bondIdStatusMapping[item.id],
              }));
            setData(filteredBondData);
          }
          break;
        case 2:
          setData(uploadData.faqs || []);
          break;
        case 3:
          setData(uploadData.testimonials || []);
          break;
        default:
          break;
      }

      // Close modal after successful update
      setIsModalOpen(false);
      
      console.log("upload data response", response);
    } catch (error) {
      console.error("Error uploading data:", error);
    }
  };

  const handleSubmit = (formData) => {
    const updatedDataToUpload = {
      ...cmsData,
      homeCards: cardEditData 
        ? cmsData.homeCards.map(card => 
            card.title === cardEditData.title 
              ? { 
                  title: formData.title || cardEditData.title,
                  description: formData.description || cardEditData.description,
                  status: card.status
                }
              : card
          )
        : [...cmsData.homeCards, { ...formData, status: true }]
    };
    
    uploadData(updatedDataToUpload);
    setCardEditData(null);
  };
  const handleBondSubmit = (formData) => {
    // Check for duplicates in existing data
    const duplicates = formData.filter(newBond => 
      data.some(existingBond => existingBond.id === newBond.id)
    );

    if (duplicates.length > 0) {
      toast.warning(`${duplicates.map(d => d.name).join(', ')} already exists in the list`);
      return;
    }

    // Handle the form data
    const updatedData = formData?.map((item) => ({
      // ...item,
      id: item.id,
      status: true,
    }));
    const mergedData = [
      ...new Map(
        [...updatedData, ...data].map((item) => [item.id, item])
      ).values(),
    ];

    const updatedDataToUpload = {
      ...cmsData,
      bondIds: mergedData,
    };
    uploadData(updatedDataToUpload);
  };
  const handleFaqSubmit = (formData) => {
    let updatedFaqs;
    
    if (faqEditData) {
      // When editing, maintain the original position by mapping through the array
      updatedFaqs = cmsData?.faqs?.map(faq => 
        faq.questtion === faqEditData.questtion
          ? {
              answer: formData?.answer,
              questtion: formData?.question,
              status: true,
            }
          : faq
      );
    } else {
      // When adding new, append to the existing array
      const newFaq = {
        answer: formData?.answer,
        questtion: formData?.question,
        status: true,
      };
      updatedFaqs = [...(cmsData?.faqs || []), newFaq];
    }

    const updatedDataToUpload = {
      ...cmsData,
      faqs: updatedFaqs,
    };
    
    uploadData(updatedDataToUpload);
    setFaqEditData(null);
  };
  const handleTestimonialSubmit = (formData) => {
    const testimonialData = {
      id: formData?.id,
      name: formData?.name,
      designation: formData?.position,
      description: formData?.comment,
      status: true,
    };

    let updatedTestimonials;
    if (testimonialEditData) {
      // Update the existing testimonial in its original position
      updatedTestimonials = cmsData?.testimonials?.map((item) =>
        item.id === testimonialData.id ? testimonialData : item
      );
    } else {
      // If adding a new testimonial, append to the existing array
      updatedTestimonials = [...(cmsData?.testimonials || []), testimonialData];
    }

    const updatedDataToUpload = {
      ...cmsData,
      testimonials: updatedTestimonials,
    };
    
    uploadData(updatedDataToUpload);
    setTestimonialEditData(null);
  };

  const homeData = [
    { name: "header", id: 1 },
    { name: "hero", id: 2 },
    { name: "footer", id: 3 },
    { name: "slider", id: 4 },
    { name: "header", id: 5 },
    { name: "header", id: 6 },
  ];

  const Highcolumns = [
    columnHelper.accessor("id", {
      cell: (info) => {
        console.log("info", info.row.index);
        return <div className="text-left">{info.row.index + 1}</div>;
      },
      header: () => <div className="text-left font-semibold">S.No.</div>,
      meta: { width: "150px" },
    }),

    columnHelper.accessor("title", {
      cell: (info) => <div className="text-left">{info.renderValue()}</div>,
      header: () => <div className="text-left font-semibold">Heading</div>,
      meta: { width: "200px" },
    }),

    columnHelper.accessor("description", {
      cell: (info) => <div className="text-center">{info.renderValue()}</div>,
      header: () => <div className="text-center font-semibold">Body</div>,
      meta: { width: "200px" },
    }),

    columnHelper.accessor("status", {
      cell: (info) => (
        <div className="text-center">
          <div
            // onClick={() =>
            //   roleType !== "admin" ? handleToggleStatus(roleId) : () => {}
            // }
            className={`relative inline-flex items-center   w-[50px] h-6 rounded-full transition-colors ${
              info.renderValue() ? "bg-green-500" : "bg-gray-300"
            }`}
          >
            {/* Toggle Circle */}
            <div
              className={`absolute w-5 h-5 bg-white rounded-full shadow-md transform transition-transform ${
                info.renderValue() ? "translate-x-6" : "translate-x-1"
              }`}
            ></div>
          </div>{" "}
        </div>
      ),
      header: () => <div className="text-center font-semibold">Status</div>,
      meta: { width: "150px" },
    }),
    // columnHelper.accessor("modify", {
    //   cell: (info) => <div className="text-center">{"N/A"}</div>,
    //   header: () => <div className="text-center font-semibold">Icon</div>,
    //   meta: { width: "150px" },
    // }),

    columnHelper.accessor("actions", {
      cell: (info) => {
        // const uniqueId = info?.row?.original?.id;
        return (
          <div className="flex justify-start">
            <img
              onClick={() => {
                setIsModalOpen(true);
                // Set the edit data for the card
                setCardEditData({
                  title: info.row.original.title,
                  description: info.row.original.description,
                  status: info.row.original.status
                });
              }}
              src={editBond}
              alt="Edit"
              className="cursor-pointer"
            />
            <img
                src={delBond}
                alt="Delete"
                className="cursor-pointer ml-2"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(info.row.original, 'homeCard', info.row.index);
                }}
              />
          </div>
        );
      },
      header: () => <div className="font-semibold">Actions</div>,
    }),
  ];
  const faqcolumns = [
    columnHelper.accessor("id", {
      cell: (info) => <div className="text-left">{info.row.index + 1}</div>,
      header: () => <div className="text-left font-semibold">S.No.</div>,
      meta: { width: "150px" },
    }),

    columnHelper.accessor("questtion", {
      cell: (info) => (
        <div className="text-start">
          <div dangerouslySetInnerHTML={{ __html: info.renderValue() }} />
        </div>
      ),
      header: () => <div className="text-left font-semibold">Question</div>,
      meta: { width: "200px" },
    }),

    columnHelper.accessor("answer", {
      cell: (info) => (
        <div className="text-start">
          <div dangerouslySetInnerHTML={{ __html: info.renderValue() }} />
        </div>
      ),
      header: () => <div className="text-center font-semibold">Answer</div>,
      meta: { width: "200px" },
    }),

    columnHelper.accessor("status", {
      cell: (info) => (
        <div className="text-center">
          {/* {info.renderValue() === true ? `True` : `False`} */}
          <div
            // onClick={() =>
            //   roleType !== "admin" ? handleToggleStatus(roleId) : () => {}
            // }
            className={`relative inline-flex items-center   w-[50px] h-6 rounded-full transition-colors ${
              info.renderValue() ? "bg-green-500" : "bg-gray-300"
            }`}
          >
            {/* Toggle Circle */}
            <div
              className={`absolute w-5 h-5 bg-white rounded-full shadow-md transform transition-transform ${
                info.renderValue() ? "translate-x-6" : "translate-x-1"
              }`}
            ></div>
          </div>
        </div>
      ),
      header: () => <div className="text-center font-semibold">Status</div>,
      meta: { width: "150px" },
    }),

    columnHelper.accessor("actions", {
      cell: (info) => {
        // const uniqueId = info?.row?.original?.id;
        return (
          <div className="flex justify-start">
            <img
              onClick={() => {
                setFaqEditData(info?.row?.original);
                setIsModalOpen(true);
              }}
              src={editBond}
              alt="Edit"
              className="cursor-pointer"
            />
            <img
                src={delBond}
                alt="Delete"
                className="cursor-pointer ml-2"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(info.row.original, 'faq', info.row.index);
                }}
              />
          </div>
        );
      },
      header: () => <div className="font-semibold">Actions</div>,
    }),
  ];
  const testimonialcolumns = [
    columnHelper.accessor("id", {
      cell: (info) => <div className="text-left">{info.row.index + 1}</div>,
      header: () => <div className="text-left font-semibold">S.No.</div>,
      meta: { width: "150px" },
    }),

    columnHelper.accessor("name", {
      cell: (info) => <div className="text-left">{info.renderValue()}</div>,
      header: () => <div className="text-left font-semibold">Name</div>,
      meta: { width: "300px" },
    }),

    columnHelper.accessor("designation", {
      cell: (info) => <div className="text-center">{info.renderValue()}</div>,
      header: () => <div className="text-center font-semibold">Position</div>,
      meta: { width: "300px" },
    }),
    columnHelper.accessor("description", {
      cell: (info) => <div className="text-start">{info.renderValue()}</div>,
      header: () => <div className="text-center font-semibold">Comment</div>,
      meta: { width: "150px" },
    }),

    columnHelper.accessor("status", {
      cell: (info) => (
        <div className="text-center">
          <div
            // onClick={() =>
            //   roleType !== "admin" ? handleToggleStatus(roleId) : () => {}
            // }
            className={`relative inline-flex items-center   w-[50px] h-6 rounded-full transition-colors ${
              info.renderValue() ? "bg-green-500" : "bg-gray-300"
            }`}
          >
            {/* Toggle Circle */}
            <div
              className={`absolute w-5 h-5 bg-white rounded-full shadow-md transform transition-transform ${
                info.renderValue() ? "translate-x-6" : "translate-x-1"
              }`}
            ></div>
          </div>{" "}
        </div>
      ),
      header: () => <div className="text-center font-semibold">Status</div>,
      meta: { width: "200px" },
    }),

    columnHelper.accessor("actions", {
      cell: (info) => {
        const name = info?.row?.original?.name;
        console.log("info?.row?.original", info?.row?.original);
        
        // Ensure the testimonial has an ID
        const testimonialWithId = {
          ...info?.row?.original,
          id: info?.row?.original?.id || info?.row?.original?.name || `testimonial_${Math.random().toString(36).substr(2, 9)}`
        };
        
        return (
          <div className="flex justify-start">
            <img
              onClick={() => {
                setTestimonialEditData(testimonialWithId);
                setIsModalOpen(true);
              }}
              src={editBond}
              alt="Edit"
              className="cursor-pointer"
            />
            <img
                src={delBond}
                alt="Delete"
                className="cursor-pointer ml-2"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(testimonialWithId, 'testimonial', info.row.index);
                }}
              />
          </div>
        );
      },
      header: () => <div className="font-semibold">Actions</div>,
    }),
  ];
  const handPickedColumn = [
    columnHelper.accessor("id", {
      cell: (info) => <div className="text-left">{info.row.index + 1}</div>,
      header: () => <div className="text-left font-semibold">S.No.</div>,
      meta: { width: "150px" },
    }),

    columnHelper.accessor("name", {
      cell: (info) => <div className="text-left">{info.renderValue()}</div>,
      header: () => <div className="text-left font-semibold">Bond Name</div>,
      meta: { width: "200px" },
    }),

    columnHelper.accessor("status", {
      cell: (info) => (
        <div className="text-center">
          <div
            // onClick={() =>
            //   roleType !== "admin" ? handleToggleStatus(roleId) : () => {}
            // }
            className={`relative inline-flex items-center   w-[50px] h-6 rounded-full transition-colors ${
              info.renderValue() ? "bg-green-500" : "bg-gray-300"
            }`}
          >
            {/* Toggle Circle */}
            <div
              className={`absolute w-5 h-5 bg-white rounded-full shadow-md transform transition-transform ${
                info.renderValue() ? "translate-x-6" : "translate-x-1"
              }`}
            ></div>
          </div>{" "}
        </div>
      ),
      header: () => <div className="text-center font-semibold">Status</div>,
      meta: { width: "200px" },
    }),

    columnHelper.accessor("actions", {
      cell: (info) => {
        // const uniqueId = info?.row?.original?.id;
        return (
          <div className="flex justify-start">
            <img
              onClick={() => {
                setbondEditData(info?.row?.original);
                setIsModalOpen(true);
              }}
              src={editBond}
              alt="Edit"
              className="cursor-pointer"
            />
            <img
                src={delBond}
                alt="Delete"
                className="cursor-pointer ml-2"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(info.row.original, 'bond', info.row.index);
                }}
              />
          </div>
        );
      },
      header: () => <div className="font-semibold">Actions</div>,
    }),
  ];

  const tabData = [
    { label: "High Yielding Fixed Income (HYFI) Securities" },
    { label: "Hand Picked" },
    { label: "FAQ" },
    { label: "Testimonials" },
  ];

  const handleStatusToggle = async (item, type, index) => {
    // Create a copy of the current data
    const updatedData = [...data];
    
    // Find and update the item's status using index
    if (index !== -1) {
      updatedData[index] = {
        ...updatedData[index],
        status: !updatedData[index].status
      };
    }

    // Update local state
    setData(updatedData);

    // Prepare data for API based on active tab
    let apiData = { ...cmsData };
    switch (activeTab) {
      case 0:
        apiData.homeCards = updatedData;
        break;
      case 1:
        apiData.bondIds = updatedData.map(bond => ({
          id: bond.id,
          status: bond.status
        }));
        break;
      case 2:
        apiData.faqs = updatedData;
        break;
      case 3:
        apiData.testimonials = updatedData;
        break;
      default:
        break;
    }

    try {
      // API call
      const response = await axios.post(
        `${base_url}/${api_type}/cms/homeContent/set`,
        apiData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      
      // Update Redux store with new data
      dispatch(updateCmsData(apiData));
      
      //  success toast/notification here
      console.log("Status updated successfully");
    } catch (error) {
      // Revert the local state change on error
      setData([...data]);
      console.error("Error updating status:", error);
      // show an error toast/notification here
    }
  };

  const handleDelete = async (item, type, index) => {
    if (!window.confirm('Are you sure you want to delete this item?')) {
      return;
    }
    
    // Create a copy of the current data
    const updatedData = [...data];
    
    // Remove the item at the specified index
    updatedData.splice(index, 1);
    
    // Update local state
    setData(updatedData);

    // Prepare data for API based on active tab
    let apiData = { ...cmsData };
    switch (activeTab) {
      case 0:
        apiData.homeCards = updatedData;
        break;
      case 1:
        apiData.bondIds = updatedData.map(bond => ({
          id: bond.id,
          status: bond.status
        }));
        break;
      case 2:
        apiData.faqs = updatedData;
        break;
      case 3:
        apiData.testimonials = updatedData;
        break;
      default:
        break;
    }

    try {
      // API call
      const response = await axios.post(
        `${base_url}/${api_type}/cms/homeContent/set`,
        apiData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      
      // Update Redux store with new data
      dispatch(updateCmsData(apiData));
      
      toast.success("Item deleted successfully");
    } catch (error) {
      // Revert the local state change on error
      setData([...data]);
      console.error("Error deleting item:", error);
      toast.error("Failed to delete item");
    }
  };

  const getColumn = () => {
    const statusCell = (info) => (
      <div className="text-center">
        <div
          onClick={(e) => {
            e.stopPropagation();
            handleStatusToggle(info.row.original, 
              activeTab === 2 ? 'faq' : 
              activeTab === 3 ? 'testimonial' : 
              activeTab === 1 ? 'bond' : 'default',
              info.row.index // Pass the index
            );
          }}
          className={`relative inline-flex items-center cursor-pointer w-[50px] h-6 rounded-full transition-colors ${
            info.getValue() ? "bg-green-500" : "bg-gray-300"
          }`}
        >
          <div
            className={`absolute w-5 h-5 bg-white rounded-full shadow-md transform transition-transform ${
              info.getValue() ? "translate-x-6" : "translate-x-1"
            }`}
          />
        </div>
      </div>
    );

    // Update status cell in all column definitions
    const columns = [Highcolumns, handPickedColumn, faqcolumns, testimonialcolumns];
    
    columns.forEach(columnSet => {
      const statusColumn = columnSet.find(col => col.accessorKey === 'status' || col.accessor === 'status');
      if (statusColumn) {
        statusColumn.cell = statusCell;
      }
    });

    return columns[activeTab] || null;
  };

  const addData = () => {
    const tabDataMapping = {
      0: cmsData?.homeCards || [],
      // 1: cmsData?.bondIds || [],
      2: cmsData?.faqs || [],
      3: cmsData?.testimonials || [],
    };

    setData(tabDataMapping[activeTab] || []);
    if (activeTab === 1 && cmsData?.bondIds) {
      const bondIdStatusMapping = cmsData?.bondIds?.reduce((acc, bond) => {
        acc[bond.id] = bond.status;
        return acc;
      }, {});

      const getFilterBondData = cmsBondListData
        ?.filter((item) => bondIdStatusMapping?.hasOwnProperty(item.id))
        .map((item) => ({
          ...item,
          status: bondIdStatusMapping[item.id],
        }));

      console.log("getFilterBondData", getFilterBondData);
      setData(getFilterBondData);
    }
  };

  useEffect(() => {
    if (cmsData) {
      switch (activeTab) {
        case 0:
          setData(cmsData.homeCards || []);
          break;
        case 1:
          if (cmsData.bondIds && cmsBondListData) {
            const bondIdStatusMapping = cmsData.bondIds.reduce((acc, bond) => {
              acc[bond.id] = bond.status;
              return acc;
            }, {});

            const filteredBondData = cmsBondListData
              .filter((item) => bondIdStatusMapping.hasOwnProperty(item.id))
              .map((item) => ({
                ...item,
                status: bondIdStatusMapping[item.id],
              }));

            setData(filteredBondData);
          }
          break;
        case 2:
          setData(cmsData.faqs || []);
          break;
        case 3:
          setData(cmsData.testimonials || []);
          break;
        default:
          setData([]);
      }
    }
  }, [activeTab, cmsData, cmsBondListData]);

  // console.log("data", data);
  // console.log("cms data", cmsData);
  // console.log("cmsBondListData data", cmsBondListData);

  return (
    <div className="w-full p-11">
      {/* <h1 className="text-[#252C32] text-[24px] font-bold">
          HomePage Management
        </h1> */}
      <div className="w-fit mt-11 flex items-center justify-between border border-gray-300  mb-6">
        {/* Render Tabs Dynamically */}
        {tabData.map((tab, index) => (
          <div
            key={index}
            onClick={() => setActiveTab(index)}
            className={`px-6 py-2 font-semibold cursor-pointer font-montserrat ${
              activeTab === index
                ? "text-white bg-[#035C98] "
                : "text-gray-800 bg-[#FFFFFF] border-r border-[#E8E8E8]"
            }`}
          >
            {tab.label}
          </div>
        ))}

        {/* Dashed Divider */}
      </div>
      <div className="bg-white p-4 rounded-lg mb-6 shadow-md mt-10 flex justify-between items-center w-full">
        <h5 className="text-[#252C32] text-[18px] font-bold">
          {tabData[activeTab].label}
        </h5>
        {activeTab !== 0 && (
          <div
            className="bg-[#2D659F] px-4 py-2 text-white rounded-xl flex items-center gap-2 cursor-pointer"
            onClick={() => setIsModalOpen(true)}
          >
            <BsPlusSquare size={18} className="mt-px" />
            Add new
          </div>
        )}
      </div>

      {/* Table Section */}
      <div className="overflow-x-auto w-full mb-6">
        <ReactTable
          key={JSON?.stringify(data)}
          defaultData={data ? data : []}
          columns={getColumn()}
          className="table-auto w-full text-sm border-collapse"
        />
      </div>

      {/* Pagination Section
      {bondDetails?.length > 0 && (
        <div className="w-full mt-4 flex justify-center">
          <CustomPagination
            currentPage={page}
            setCurrentPage={setPage}
            totalItems={total}
            itemsPerPage={pageSize}
            maxPageNumbersToShow={5}
          />
        </div>
      )} */}
      {activeTab === 0 && isModalOpen && (
        <AddCardDetailsModal
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            setCardEditData(null);
          }}
          onSubmit={handleSubmit}
          editData={cardEditData}
        />
      )}
      <AddHandpickedBondModal
        isOpen={activeTab === 1 ? isModalOpen : false}
        onClose={() => {
          setIsModalOpen(false);
          setbondEditData(null);
        }}
        onSubmit={handleBondSubmit}
        editData={bondEditData}
      />
      <AddFAQModal
        isOpen={activeTab === 2 ? isModalOpen : false}
        onClose={() => {
          setIsModalOpen(false);
          setFaqEditData(null);
        }}
        onSubmit={handleFaqSubmit}
        editData={faqEditData}
      />
      <AddTestimonialModal
        isOpen={activeTab === 3 ? isModalOpen : false}
        onClose={() => {
          setIsModalOpen(false);
          setTestimonialEditData(null);
        }}
        onSubmit={handleTestimonialSubmit}
        editData={testimonialEditData}
      />
    </div>
  );
}

export default HomePagemanage;
